/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 */

import { permissionObj } from '../../../../Helpers/permission';
import {VIEW_TYPE} from "../../../../enums/ViewType";
import {EXPORT_FILE_TYPE_MODEL} from "../../../../components/ModuleExportDataButton/Model/Model";
import ic_excel from "../../../../assets/images/ic-excel.svg";

export const TABS_FOODIE = {
    SCHEDULES: {
        INDEX: 0,
        TRANS: "schedules",
    },
    CAFETERIAS: {
        INDEX: 1,
        TRANS: "cafeterias",
    },
    MENUS: {
        INDEX: 2,
        TRANS: "menus",
    },
    DISHES: {
        INDEX: 3,
        TRANS: "meals",
    },
    INGREDIENTS: {
        INDEX: 4,
        TRANS: "ingredients",
    },
    REQUESTS: {
        INDEX: 5,
        TRANS: "requests",
    },
    MANAGE: {
        INDEX: 6,
        TRANS: "manage",
    }
}

export const SUB_VIEW_MODEL = {
    SCHEDULE: {
        SHIFTS: 'SHIFTS',
        MEALS: 'MEALS',
        ACCESS_CODE: 'ACCESS_CODE',
    },
    MENUS: {
        MENUS: 'MENUS',
        CALENDAR: 'CALENDAR',
        MEAL_FORECAST: 'MEAL_FORECAST',
    },
    MANAGE: {
        DINING_ATTENDANCE: 'DINING_ATTENDANCE',
        SETTINGS: 'SETTINGS',
        DEPARTMENT_POLICIES: 'DEPARTMENT_POLICIES',
        TOTAL_MEALS: 'TOTAL_MEALS',
    },
    REQUEST:{
       REQUEST: 'REQUEST',
       HISTORY: 'HISTORY',
    }
};

export const getOptions = ({ setShowModal, setExcel, t, setExportModuleDataOption}) => [
    {
        id: `mim_med_${EXPORT_FILE_TYPE_MODEL.PILGRIMS_ACCESS_REPORT}`,
        option: t(EXPORT_FILE_TYPE_MODEL.PILGRIMS_ACCESS_REPORT.toUpperCase()),
        img: ic_excel,
        action: ( ) => {
            setExcel(true);
            setShowModal(true);
            setExportModuleDataOption(EXPORT_FILE_TYPE_MODEL.PILGRIMS_ACCESS_REPORT);
        }
    },
    {
        id: `mim_med_${EXPORT_FILE_TYPE_MODEL.PILGRIMS_MEAL_TIME_REPORT}`,
        option: t(EXPORT_FILE_TYPE_MODEL.PILGRIMS_MEAL_TIME_REPORT.toUpperCase()),
        img: ic_excel,
        action: () => {
            setExcel(true);
            setShowModal(true);
            setExportModuleDataOption(EXPORT_FILE_TYPE_MODEL.PILGRIMS_MEAL_TIME_REPORT);
        }
    }
];


export function TAB_PERMISSION_FOODIE(subView, selectedOption, cafeteriaId, subViewChild) {
    return {
        CREATE: {
            [TABS_FOODIE.SCHEDULES.INDEX]:
                subView === SUB_VIEW_MODEL.SCHEDULE.SHIFTS
                    ? permissionObj?.WEB_FOODIE_SHIFT_CREATE
                    : subView === SUB_VIEW_MODEL.SCHEDULE.ACCESS_CODE
                      ? permissionObj?.WEB_FOODIE_ACCESS_CREATE
                      : permissionObj?.WEB_FOODIE_MEAL_TIME_CREATE,
            [TABS_FOODIE.CAFETERIAS.INDEX]: permissionObj?.WEB_FOODIE_CAFETERIA_CREATE,
            [TABS_FOODIE.MENUS.INDEX]:
                subView === SUB_VIEW_MODEL.MENUS.MENUS ? permissionObj?.WEB_FOODIE_MENU_CREATE : undefined,
            [TABS_FOODIE.DISHES.INDEX]: permissionObj?.WEB_FOODIE_ITEM_CREATE,
            [TABS_FOODIE.INGREDIENTS.INDEX]: permissionObj?.WEB_INGREDIENT_CREATE,
        },
        DELETE: {
            [TABS_FOODIE.SCHEDULES.INDEX]:
                subView === SUB_VIEW_MODEL.SCHEDULE.SHIFTS
                    ? permissionObj?.WEB_FOODIE_SHIFT_DELETE
                    : subView === SUB_VIEW_MODEL.SCHEDULE.ACCESS_CODE
                      ? permissionObj?.WEB_FOODIE_ACCESS_DELETE
                      : permissionObj?.WEB_FOODIE_MEAL_TIME_DELETE,
            [TABS_FOODIE.MENUS.INDEX]: [SUB_VIEW_MODEL.MENUS.MENUS].includes(subView)
                ? permissionObj?.WEB_FOODIE_MENU_DELETE
                : undefined,
            [TABS_FOODIE.DISHES.INDEX]: permissionObj?.WEB_FOODIE_ITEM_DELETE,
            [TABS_FOODIE.CAFETERIAS.INDEX]: permissionObj?.WEB_FOODIE_CAFETERIA_DELETE,
            [TABS_FOODIE.INGREDIENTS.INDEX]: permissionObj?.WEB_INGREDIENT_DELETE,
        },
        UPDATE: {
            [TABS_FOODIE.MANAGE.INDEX]:
                subView === SUB_VIEW_MODEL.MANAGE.DINING_ATTENDANCE
                    ? 0
                    : subView === SUB_VIEW_MODEL.MANAGE.SETTINGS
                      ? permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_UPDATE
                      : false,
        },
        EXPORT: {
            [TABS_FOODIE.CAFETERIAS.INDEX]: permissionObj?.WEB_FOODIE_CAFETERIA_EXPORT,
            [TABS_FOODIE.INGREDIENTS.INDEX]: permissionObj?.WEB_INGREDIENT_EXPORT,
            [TABS_FOODIE.DISHES.INDEX]: permissionObj?.WEB_FOODIE_ITEM_EXPORT,
            [TABS_FOODIE.MENUS.INDEX]:
                subView === SUB_VIEW_MODEL.MENUS.CALENDAR
                    ? false
                    : subView === SUB_VIEW_MODEL.MENUS.MENUS
                      ? permissionObj?.WEB_FOODIE_MENU_EXPORT
                      : cafeteriaId
                        ? permissionObj.WEB_FOODIE_MEAL_FORECAST_EXPORT
                        : false,
            [TABS_FOODIE.REQUESTS.INDEX]:
                subView === SUB_VIEW_MODEL.REQUEST.HISTORY
                    ? permissionObj?.WEB_FOODIE_REQUEST_HISTORY_EXPORT
                    : permissionObj?.WEB_FOODIE_REQUEST_EXPORT,
            [TABS_FOODIE.MANAGE.INDEX]:
                subView === SUB_VIEW_MODEL.MANAGE.DINING_ATTENDANCE
                    ? permissionObj?.WEB_FOODIE_ATTENDANCE_EXPORT
                    : subView === SUB_VIEW_MODEL.MANAGE.TOTAL_MEALS && subViewChild === VIEW_TYPE.LIST.name
                      ? permissionObj?.WEB_TOTAL_MEALS_EXPORT
                      : false,
        },
        ADVANCE_SEARCH: {
            [TABS_FOODIE.REQUESTS.INDEX]: subView === SUB_VIEW_MODEL.REQUEST.HISTORY,
            [TABS_FOODIE.MANAGE.INDEX]:
                subView === SUB_VIEW_MODEL.MANAGE.DINING_ATTENDANCE ||
                (subView === SUB_VIEW_MODEL.MANAGE.TOTAL_MEALS && subViewChild === VIEW_TYPE.LIST.name),
        },
    };
}


export const MODEL_CONTEXT = {
    tabIndex: null,
    disabledBtnDelete: true,
    btnUpdate:null,
    modalCreate: false,
    modalDelete: false,
    modalCancel: false,
    modalSummary: false,
    showBtnExport: false,
    showBtnImport: false,
};
